'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBodyClassname = require('react-body-classname');

var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _Modal = require('components/Modal');

var _components = require('components');

var _Media = require('components/Media');

var _translate = require('../../redux/i18n/translate');

var _translate2 = _interopRequireDefault(_translate);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _video = require('redux/modules/video');

var videoActions = _interopRequireWildcard(_video);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Home = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return { videoFirstTime: state.video.firstTime, currentLanguage: state.language.lang };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)(videoActions, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home(props) {
    (0, _classCallCheck3.default)(this, Home);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call(this, props));

    _this.toggleVideoState = function () {
      _this.props.toggleVideoState();
    };

    _this.state = {
      videoShow: false,
      opened: false,
      goTo: '/caso1/',
      inTab: true
    };

    _this.showIntro = _this.showIntro.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Home, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.videoFirstTime) {
        this.refs.videoHome.api.pause();
        this.setState({ videoShow: false });
      }
      this.context.setMute(false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.context.setMute(true);
    }
  }, {
    key: 'hideIntro',
    value: function hideIntro() {
      this.refs.videoHome.api.pause();

      this.setState({ videoShow: false });

      //Cuando pasamos del video o ya lo hemos visto, seteamos firstTime of Video
      this.toggleVideoState();

      var url = _reactDom2.default.findDOMNode(this.refs.caseLink).href;
      this.context.router.push(url);
    }
  }, {
    key: 'showIntro',
    value: function showIntro() {
      this.context.setMute(true);

      this.refs.videoHome._volume(0);
      this.refs.videoHome.api.play();
      this.fadeInSound('videoHome');

      this.setState({ videoShow: true });
    }
  }, {
    key: 'showInstructions',
    value: function showInstructions(ev) {
      ev.preventDefault();

      //Vemos video e instrucciones sólo la primera vez que entramos
      if (this.props.videoFirstTime) {
        this.setState({ opened: true });

        //Lo volvemos a ocultar pasado el tiempo de animación
        var timeToHide = 6000 * 3; //2 slides * 4seg es lo que hay entre frase y frase (slides)
        setTimeout(function () {
          this.showIntro();
          this.setState({
            opened: false
          });
        }.bind(this), timeToHide);
      } else {
        var url = _reactDom2.default.findDOMNode(this.refs.caseLink).href;
        this.context.router.push(url);
      }
    }
  }, {
    key: 'goToProject',
    value: function goToProject(ev) {
      ev.preventDefault();

      this.context.router.goTo = 4;

      var url = _reactDom2.default.findDOMNode(this.refs.projectLink).href + '/';
      this.hideInstructionsAndGoTo(url);
    }
  }, {
    key: 'fadeOutSound',
    value: function fadeOutSound(videoElement) {
      var self = this;
      var vol = 1;
      var intervalOut = 25;

      var intervalID = setInterval(function () {
        if (vol > 0) {
          vol -= 0.05;
          self.refs[videoElement]._volume(vol.toFixed(2));
        } else {
          clearInterval(intervalID);
        }
      }, intervalOut);
    }
  }, {
    key: 'fadeInSound',
    value: function fadeInSound(videoElement) {

      var self = this;
      var vol = 0;
      var intervalOut = 50;

      var intervalID = setInterval(function () {
        if (vol < 1) {
          vol += 0.05;
          self.refs[videoElement]._volume(vol.toFixed(2));
        } else {
          clearInterval(intervalID);
        }
      }, intervalOut);
    }
  }, {
    key: 'render',
    value: function render() {
      var strings = this.props.strings;

      var text = strings.parallaxContent;
      var trackLabel = this.props.currentLanguage === "es" ? "Spanish" : "English";

      var footerClass = (0, _classnames2.default)({
        'footerHome': true,
        'hidden': this.state.videoShow
      });

      var videoClass = (0, _classnames2.default)({
        'videoFull': true,
        'full': this.state.videoShow,
        'hidden': !this.state.videoShow
      });

      return _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        {
          transitionName: 'view',
          transitionAppear: true,
          transitionAppearTimeout: 1500,
          transitionEnter: true,
          transitionEnterTimeout: 1500,
          transitionLeave: true,
          transitionLeaveTimeout: 1500 },
        _react2.default.createElement(
          _reactBodyClassname2.default,
          { className: 'home' },
          _react2.default.createElement(
            'div',
            { className: 'home' },
            _react2.default.createElement(
              'video',
              { className: 'bgVideo', width: '100%', height: '100%', autoPlay: true, loop: true, muted: true },
              _react2.default.createElement('source', { src: this.context.baseUrl + "/media/video/bgHomeLow.mp4", type: 'video/mp4' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'container' },
              _react2.default.createElement(
                'div',
                { className: 'table' },
                _react2.default.createElement(
                  'div',
                  { className: 'cell' },
                  _react2.default.createElement(
                    'h1',
                    null,
                    _react2.default.createElement(_components.Parallax, { content: text, parallaxClass: 'homePage' })
                  ),
                  _react2.default.createElement('h2', { dangerouslySetInnerHTML: { __html: strings.h2 } }),
                  _react2.default.createElement(
                    'h3',
                    null,
                    strings.h2sub
                  ),
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { onClick: this.showInstructions.bind(this), ref: 'caseLink', className: 'nextLink', to: "/" + this.context.project + "/" + this.props.currentLanguage + "/" + strings.linkCase1, draggable: 'false' },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        strings.titleCase1
                      ),
                      _react2.default.createElement('i', { className: 'icon-arrowright' })
                    )
                  ),
                  _react2.default.createElement('span', { className: 'smallBar' }),
                  _react2.default.createElement(
                    'p',
                    null,
                    strings.h4
                  )
                )
              ),
              _react2.default.createElement(_Modal.Modal, { isOpen: this.state.opened, strings: strings }),
              _react2.default.createElement(
                'div',
                { key: 'videoHome', className: videoClass },
                _react2.default.createElement('div', { className: 'vignette noise box' }),
                _react2.default.createElement(_Media.Video, { ref: 'videoHome', sources: [this.context.baseUrl + "/media/video/introHome.mp4"],
                  subtitles: [{ src: this.context.baseUrl + "/media/subtitles/intro-" + this.props.currentLanguage + ".vtt", label: trackLabel, lang: this.props.currentLanguage }],
                  autoPlay: false,
                  activeSubtitle: 0,
                  subtitleOn: true,
                  isSubtitled: true,
                  layout: 'squareLayout',
                  icons: {
                    sound: _react2.default.createElement('i', { className: 'icon-sound' }),
                    mute: _react2.default.createElement('i', { className: 'icon-mute' }),
                    subtitles: _react2.default.createElement('i', { className: 'icon-rectangle-subtitle' })
                  },
                  controls: true,
                  ended: this.hideIntro.bind(this),
                  width: '100%',
                  height: '100%' }),
                _react2.default.createElement(
                  'div',
                  { className: 'centralButton' },
                  _react2.default.createElement(
                    'div',
                    { onClick: this.hideIntro.bind(this), className: "nextView" },
                    _react2.default.createElement(
                      'span',
                      null,
                      strings.buttonContinue
                    ),
                    _react2.default.createElement('i', { className: 'icon-arrowright' })
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: footerClass },
              _react2.default.createElement(
                'div',
                { className: 'links' },
                _react2.default.createElement(
                  'a',
                  { href: strings.footer.elem1.link, target: '_blank' },
                  _react2.default.createElement(
                    'span',
                    null,
                    strings.footer.elem1.name
                  )
                ),
                _react2.default.createElement(
                  'a',
                  { href: strings.footer.elem2.link, target: '_blank' },
                  _react2.default.createElement('i', { className: 'icon-logolab' })
                ),
                _react2.default.createElement('span', { className: 'line' }),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { ref: 'projectLink', to: "/" + this.context.project + "/" + this.props.currentLanguage + "/" + strings.footer.elem3.link, draggable: 'false' },
                  _react2.default.createElement(
                    'span',
                    null,
                    strings.footer.elem3.name
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Home;
}(_react.Component), _class2.propTypes = {
  strings: _react.PropTypes.object,
  toggleVideoState: _react.PropTypes.func
}, _class2.contextTypes = {
  toggleMute: _react.PropTypes.func,
  setMute: _react.PropTypes.func,
  exitTab: _react.PropTypes.func,
  baseUrl: _react.PropTypes.string.isRequired,
  project: _react.PropTypes.string.isRequired,
  router: _react2.default.PropTypes.object.isRequired
}, _temp)) || _class);
;

exports.default = (0, _translate2.default)('Home')(Home);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.js
// module id = 817
// module chunks = 0